import { render } from "./SchoolEditTableRowText.vue?vue&type=template&id=3e9a058d&scoped=true&ts=true"
import script from "./SchoolEditTableRowText.vue?vue&type=script&lang=ts"
export * from "./SchoolEditTableRowText.vue?vue&type=script&lang=ts"

import "./SchoolEditTableRowText.vue?vue&type=style&index=0&id=3e9a058d&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e9a058d"]])

export default __exports__